// Mapper for Employee Lookup (lightweight endpoint for filters/selectors)
import { formatPersonName } from '@/utils';
import type { LC_EmployeeLookupItem, EmployeeLookupOption } from '../types';

/**
 * Maps LC_EmployeeLookupItem to EmployeeLookupOption for UI consumption
 * Label contains only the name, RUT is stored separately for supportingText
 * The backend already returns the name as "ApellidoPaterno ApellidoMaterno Nombres",
 * so only the capitalization is normalized here.
 */
export const mapEmployeeLookupItemToOption = (
  item: LC_EmployeeLookupItem,
): EmployeeLookupOption => {
  const name = formatPersonName(item.employeeName ?? '') || 'Sin nombre';
  const rut = item.employeeTaxIdentificationNumber?.trim() || null;

  return {
    value: item.employeeId,
    label: name,
    rut,
  };
};

/**
 * Maps array of LC_EmployeeLookupItem to array of EmployeeLookupOption
 */
export const mapEmployeeLookupItems = (
  items: LC_EmployeeLookupItem[],
): EmployeeLookupOption[] => {
  if (!items || items.length === 0) {
    return [];
  }
  return items.map(mapEmployeeLookupItemToOption);
};
